// extracted by mini-css-extract-plugin
module.exports = {"collection":"index-collection-1jom1","collectionHeader":"index-collectionHeader-2Pgpd","menulist":"index-menulist-3ke9R","light":"index-light-GfuL5"};